import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export interface AuthGateProps {
  /** Taken from the portal's OWN auth context — never a shared "any session" flag. */
  isAuthenticated: boolean;
  /** Where to send visitors without a session for this portal. */
  loginPath: string;
  children: ReactNode;
}

/** Sends unauthenticated visitors to a portal's login page, remembering where they were headed. */
export function AuthGate({ isAuthenticated, loginPath, children }: AuthGateProps) {
  const location = useLocation();

  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={loginPath} replace state={{ from }} />;
  }

  return <>{children}</>;
}
